import React, { useEffect, useState, useCallback } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

function Privacy() {
	const applicationId = sessionStorage.getItem('applicationId') || '';
	const languageData = JSON.parse(sessionStorage.getItem('languages')) || {};
	const [_languages, setLanguages] = useState([]);
	const [language, setLanguage] = useState(Object.keys(languageData).length > 0 ? Object.keys(languageData)[0] : '');
	const [purposes, setPurposes] = useState([]);
	const [translatedPurposes, setTranslatedPurposes] = useState([]);
	const [_consentId, setConsentId] = useState(null);
	const [formData, setFormData] = useState(() => {
		const userStoredData = JSON.parse(localStorage.getItem('user') || '{}');
		const initialMode = userStoredData.phone ? 'sms' : 'email';
		const initialIdentifier = userStoredData[initialMode] || '';

		return {
			selectedOptions: JSON.parse(localStorage.getItem(`${initialMode}SelectedOptions`) || '[]'),
			consentGiven: null,
			modeOfCommunication: initialMode,
			userIdentifier: initialIdentifier,
		};
	});

	const originalTitle = 'Privacy Policy';
	const originalStatement =
		'We collect and process your personal data for specific purposes based on your consent, as per the Digital Personal Data Protection Act, 2023. You can select the purposes for which you wish to share your data. To exercise your rights or raise any concerns, please visit the Data Principal Rights Portal.';
	const [privacyTitle, setPrivacyTitle] = useState(originalTitle);
	const [privacyStatement, setPrivacyStatement] = useState(originalStatement);

	const originalModeLabel = 'Mode of Communication:';
	const originalModeOptions = ['email', 'sms'];
	const [modeLabel, setModeLabel] = useState(originalModeLabel);
	const [modeOptions, setModeOptions] = useState({
		email: originalModeOptions[0],
		sms: originalModeOptions[1],
	});

	useEffect(() => {
		// const fetchLanguages = async () => {
		//   try {
		// 	// const apiKey = process.env.REACT_APP_GOOGLE_TRANSLATE_API_KEY;
		// 	const apiKey = `AIzaSyCirW-cyCFUgvld1GK-2RVPGZHQ5qeKJS0`;
		// 	if (!apiKey) throw new Error('Missing Google Translate API key');

		// 	// Optionally target=en so you get language names in English
		// 	const url = `https://translation.googleapis.com/language/translate/v2/languages?key=${apiKey}&target=en`;

		// 	const res = await fetch(url);
		// 	if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
		// 	const json = await res.json();

		// 	// json.data.languages is an array of { language: "hi", name: "Hindi" } etc.
		// 	setLanguages(json.data.languages);
		//   } catch (err) {
		// 	console.error('Could not load languages:', err);
		// 	// fallback to a minimal set if you like:
		// 	setLanguages([
		// 	  { language: 'en', name: 'English' },
		// 	  { language: 'hi', name: 'Hindi' },
		// 	  { language: 'fr', name: 'French' }
		// 	]);
		//   }
		// };

		// fetchLanguages();
	}, [language]);

	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState(null);
	const [snackbarOpen, setSnackbarOpen] = useState(false);
	const [snackbarMessage, setSnackbarMessage] = useState('');
	const [snackbarBackgroundColor, setSnackbarBackgroundColor] = useState('#4caf50');

	useEffect(() => {
		const storedPurposes = sessionStorage.getItem('purposes');
		if (storedPurposes) {
			setPurposes(JSON.parse(storedPurposes));
		}
	}, []);

	useEffect(() => {
		console.log('This use Effect is triggered')
		if (language === 'en') {
			setTranslatedPurposes(purposes.map(p => ({ ...p, label: p.n })));
			setPrivacyTitle(originalTitle);
			setPrivacyStatement(originalStatement);
			setModeLabel(originalModeLabel);
			setModeOptions({
				email: originalModeOptions[0],
				sms: originalModeOptions[1],
			});
			return;
		}
		setTranslatedPurposes(purposes.map(p => ({ ...p, label: p.n })));
		setPrivacyTitle(originalTitle);
		setPrivacyStatement(originalStatement);
		setModeLabel(originalModeLabel);
		setModeOptions({
			email: originalModeOptions[0],
			sms: originalModeOptions[1],
		});
		// (async () => {
		// 	try {
		// 	  const apiKey = `AIzaSyCirW-cyCFUgvld1GK-2RVPGZHQ5qeKJS0`;
		// 	  const url = `https://translation.googleapis.com/language/translate/v2?key=${apiKey}`;
		// 	  // build one big q-array: [p.n..., title, statement]
		// 	  const q = [
		// 		...purposes.map(p => p.n),
		// 		originalTitle,
		// 		originalStatement,
		// 		originalModeLabel,              // Mode of Communication:
		//   		...originalModeOptions,         // email, sms
		// 	  ];
		// 	  const res = await fetch(url, {
		// 		method: 'POST',
		// 		headers: { 'Content-Type': 'application/json' },
		// 		body: JSON.stringify({ q, source: 'en', target: language, format: 'text' })
		// 	  });
		// 	  if (!res.ok) throw new Error(res.statusText);
		// 	  const { data: { translations } } = await res.json();

		// 	  const N = purposes.length;
		// 	  // first N => purposes
		// 	  setTranslatedPurposes(
		// 		purposes.map((p, i) => ({
		// 		  ...p,
		// 		  label: translations[i]?.translatedText || p.n
		// 		}))
		// 	  );
		// 	  // index N => title, N+1 => statement
		// 	  setPrivacyTitle(translations[N]?.translatedText || originalTitle);
		// 	  setPrivacyStatement(translations[N+1]?.translatedText || originalStatement);
		// 	  setModeLabel(translations[N + 2]?.translatedText || originalModeLabel);
		// 	  // N + 3 => translated "email"
		// 	  // N + 4 => translated "sms"
		// 	  setModeOptions({
		// 		email: translations[N + 3]?.translatedText || originalModeOptions[0],
		// 		sms:   translations[N + 4]?.translatedText || originalModeOptions[1],
		// 	  });
		// 	} catch {
		// 	  // fallback to English
		// 	  setTranslatedPurposes(purposes.map(p => ({ ...p, label: p.n })));
		// 	  setPrivacyTitle(originalTitle);
		// 	  setPrivacyStatement(originalStatement);
		// 	  setModeLabel(originalModeLabel);
		// 		setModeOptions({
		// 		email: originalModeOptions[0],
		// 		sms:   originalModeOptions[1],
		// 		});
		// 	}
		//   })();
	}, [language, purposes]);


	const handleLanguageChange = e => {
		setLanguage(e.target.value);
	};

	const handleCheckboxChange = useCallback((e) => {
		const { value, checked } = e.target;
		setFormData((prevState) => {
			const updatedSelectedOptions = checked ? [...prevState.selectedOptions, value] : prevState.selectedOptions.filter((item) => item !== value);

			localStorage.setItem(`${prevState.modeOfCommunication}SelectedOptions`, JSON.stringify(updatedSelectedOptions));
			return { ...prevState, selectedOptions: updatedSelectedOptions };
		});
	}, []);

	const handleModeChange = useCallback((e) => {
		const mode = e.target.value;
		const storedSelectedOptions = JSON.parse(localStorage.getItem(`${mode}SelectedOptions`) || '[]');
		setFormData((prevState) => ({
			...prevState,
			modeOfCommunication: mode,
			selectedOptions: storedSelectedOptions,
			userIdentifier: JSON.parse(localStorage.getItem('user') || '{}')[mode] || '',
		}));
	}, []);

	const handleConsent = async () => {
		setErrorMessage('');
		setIsLoading(true);
		try {
			const userStoredData = JSON.parse(localStorage.getItem('user') || '{}');
			const userIdentifier = formData.modeOfCommunication === 'sms' ? userStoredData.phone : userStoredData.email;

			if (!userIdentifier) {
				throw new Error('Based on Mode Of Communication, either email or phone is missing.');
			}

			const apiUrl = sessionStorage.getItem('apiUrl');
			if (!apiUrl) {
				throw new Error('API URL not found');
			}

			const bodyData = {
				application_id: applicationId,
				purpose_ids: formData.selectedOptions,
				user_email: userStoredData.email,
				user_contact: userStoredData.phone,
				age: 23,
				parent_email: '',
				mode_of_communication: formData.modeOfCommunication,
			};

			const response = await fetch(apiUrl, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(bodyData),
			});

			if (response.ok) {
				const data = await response.json();
				setConsentId(data.uuid);
				setFormData((prevState) => ({ ...prevState, consentGiven: true }));
				setSnackbarMessage('You have given your consent.');
				setSnackbarBackgroundColor('#4caf50');
				setSnackbarOpen(true);
			} else {
				throw new Error('Error saving consent: ' + response.statusText);
			}
		} catch (error) {
			setErrorMessage('Detected Duplicate Consent request Retry with different purposes: ' + error.message);
		} finally {
			setIsLoading(false);
		}
	};

	const handleSnackbarClose = () => {
		setSnackbarOpen(false);
	};

	return (
		<section
			className="flex items-center justify-center min-h-screen bg-gray-100"
			style={{
				backgroundImage: 'url("https://cdn.prod.website-files.com/650dc6e8c3edc32394341ca0/667e7109654405b4e76c8a47_fdghj.png")',
			}}
		>
			<Snackbar
				open={snackbarOpen}
				autoHideDuration={6000}
				onClose={handleSnackbarClose}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert
					onClose={handleSnackbarClose}
					severity={snackbarBackgroundColor === '#4caf50' ? 'success' : 'error'}
					sx={{ width: '100%', backgroundColor: snackbarBackgroundColor, color: '#fff' }}
				>
					{snackbarMessage}
				</Alert>
			</Snackbar>
		</section>
	);
}

export default Privacy;
